// HELPERS (docs/design/2026-10-30-helpers-visibility.md §2): how a DE is named. By default the
// role is the name ("Marketing Director"). A company that sets `settings.workforce.de_names` to
// `person` shows a DE's optional person name first ("Maya · Marketing Director"); the API sends
// `person_name` only then, so a list shows it without reading the company. The role stays the
// canonical name (mentions, tools, approvals); the person name is a label only.
import { workerName } from "@companyos/ui";
import { useQuery } from "@tanstack/react-query";
import type { Api } from "../../api/client";
import { companyQuery } from "../queries";

export type DeNames = "role" | "person";

/** "Maya · Marketing Director" for a DE with a (shown) person name, else its role. */
export function deLabel(roleName: string, personName?: string | null): string {
  const role = workerName(roleName);
  const person = personName?.trim();
  return person ? `${person} · ${role}` : role;
}

/** The company's DE naming, for the editors that offer the person name (`role` until loaded). */
export function useDeNames(api: Api, co: string): DeNames {
  const q = useQuery({ ...companyQuery(api, co), retry: false, staleTime: 5 * 60_000 });
  return q.data?.settings.workforce?.de_names === "person" ? "person" : "role";
}
